"use client";
import clsx from "clsx";
import React from "react";
export default function FullQuote(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("px-6 md:px-14 mb-16 md:mb-20 xl:mb-28 relative overflow-hidden", {
            "max-[767px]:bg-gray-30": !props.image
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mx-auto max-w-7xl relative", {
            "bg-gray-30 white-triangle": !props.image
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mx-auto relative z-10", {
            "sm:flex sm:flex-wrap gap-x-8 md:ml-16 lg:ml-32 lg:mr-10 md:pb-32": props.image,
            "md:pl-[25%] lg:pl-0 lg:max-w-2xl lg:py-24 py-10 md:py-14": !props.image
        })
    }, props.image ? /*#__PURE__*/ React.createElement("div", {
        className: "shrink-0"
    }, /*#__PURE__*/ React.createElement("img", {
        width: "240",
        className: "max-w-full md:w-40 lg:w-[190px] mb-8 md:mb-0",
        src: "".concat(props === null || props === void 0 ? void 0 : props.image),
        alt: "".concat(props === null || props === void 0 ? void 0 : props.company),
        loading: "lazy"
    })) : null, /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "flex-1": props.image
        })
    }, /*#__PURE__*/ React.createElement("img", {
        height: "36",
        className: "max-h-[36px] max-w-full mb-5",
        src: "".concat(props === null || props === void 0 ? void 0 : props.logo),
        alt: "".concat(props === null || props === void 0 ? void 0 : props.company),
        loading: "lazy"
    }), /*#__PURE__*/ React.createElement("blockquote", null, /*#__PURE__*/ React.createElement("p", {
        className: "mb-5 lg:mb-4 leading-snug text-lg md:text-2xl lg:text-[27px] lg:leading-snug font-semibold font-heading"
    }, props === null || props === void 0 ? void 0 : props.quote), /*#__PURE__*/ React.createElement("cite", {
        className: "not-italic max-[767px]:max-w-xs text-xs md:w-1/2 lg:w-2/5 block md:pr-8"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "block mb-0.5"
    }, props === null || props === void 0 ? void 0 : props.source), /*#__PURE__*/ React.createElement("span", {
        className: "block text-[#777777]"
    }, props === null || props === void 0 ? void 0 : props.role))))), props.image ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1367px",
        height: "361px",
        viewBox: "0 0 1367 361",
        version: "1.1",
        className: "absolute top-0 left-0 hidden md:block"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Line"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Persona-Page-Desktop:-Data-Experts",
        transform: "translate(-73.000000, -2247.000000)",
        stroke: "#F0F2F2",
        strokeWidth: "4"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Quote",
        transform: "translate(75.000000, 2247.000000)"
    }, /*#__PURE__*/ React.createElement("polyline", {
        id: "Angle-Line",
        transform: "translate(682.500000, 179.500000) scale(-1, 1) rotate(-180.000000) translate(-682.500000, -179.500000) ",
        points: "0 359 1.2490009e-13 192.743384 199.935971 -1.29540476e-14 1365 2.57571742e-13"
    }))))) : null), !props.image ? /*#__PURE__*/ React.createElement("div", {
        className: 'before:md:content-[""] before:md:block before:md:bg-gray-30 before:md:absolute before:md:top-0 before:md:right-0 before:md:w-1/2 before:md:h-full'
    }) : null);
}
